<template>
  <div class="relative flex w-full cursor-pointer items-center bg-inherit text-sm select-none focus:outline-hidden">
    <slot></slot>
  </div>
</template>
